import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseURL } from "../../api";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const signupApi = createApi({
  reducerPath: reducerPaths.signupApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    signup: builder.mutation({
      query: ({ payload }) => {
        return {
          url: `/auth/dealer/register`,
          body: payload,
          method: "POST"
        }
      }
    })
  }),
});

export const {
  useSignupMutation
} = signupApi;
